// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-togglebutton[data-v-fec87f58]{background-color:#bf0202}.p-highlight[data-v-fec87f58]{background-color:#32b232!important}", ""]);
// Exports
module.exports = exports;
